<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Marco Preshevski was born in 1971, in Luton, United Kingdom. After spending his childhood and adolescent years in the west of England, he attended the University of Bristol, graduating in 1993 with an honours degree in Chemistry. Marco worked for almost twenty years in healthcare, marketing communications before moving to Australia. Marco lives in Sydney, New South Wales, Australia, where he spends as much time as possible raising his daughter.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?20fe6ef0